<template>
	<appBaseModal v-if="shouldShowModal">	
		<div slot="content">
			<div class="modal__head">
				<div class="modal__head__title">Earth</div>
				<div class="modal__head__subtitle">Recommended as default by RICS guidance note. </div>
			</div>
			<div class="modal__content">
				<ul>
					<div class="col md-6">
						<li>Bank bottom</li>
						<li>Bank top</li>
						<li>Hilltops, depressions and saddles (spot heights)</li>
						<li>Mounds, spoil heaps (outline where not graded)</li>
						<li>Pitch/playground (limits only)</li>
					</div>
					<div class="col md-6">
						<li>Quarries, pits and mineral workings (limit only)</li>
						<li>Quarries, pits and mineral workings, detailed survey</li>
						<li>Retaining wall/sloping masonry base and top</li>
						<li>Terraces</li>
					</div>
				</ul>
				<div class="clearfix"></div>
				<button class="primary" @click="closeModaler">Close</button>
			</div>
		</div>
	</appBaseModal>
</template>

<script>
    import BaseModal from './BaseModal';
	export default {
		components : {
			appBaseModal : BaseModal
		},
		data(){
			return {
				compName : 'EarthModal',
			}
		},
		methods : {
			closeModaler(){
				return this.$store.commit('closeModal', '');
			}
		},
		computed : {
			shouldShowModal(){
				return this.$store.getters.getModalActive.modalName === this.compName
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/common/Modals/EarthModal.vue